module.exports = __webpack_public_path__ + "img/plat_4873.1ebf5a62.jpg";